// stores/userStore.js
import { defineStore } from "pinia";

export const useMetaDataStore = defineStore("mete_data_store", {
  persist: true,
  state: () => ({
    data: {}
  }),
  actions: {
    setData(data) {
      this.data = {
        ...this.data,
        ...data
      };
    },
    getData(key) {
      return this.data[key];
    }
  },
  $reset() {
    this.data = {};
  }
});
